var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sayfahead"},[_c('h1',[_vm._v(_vm._s(_vm.Sayfa.Adi))])]),_vm._v(" "),_c('div',{staticClass:"icerik"},[_c('BinaOzetEkran',{attrs:{"data":_vm.BinaOzetEkranData}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11fe2523","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Yonetim/sirket/Index.vue
// module id = 697
// module chunks = 0